import { FlexColumn } from '@elementary/common-ui/components';
import RuleAccordion, { RuleAccordionProps } from './RuleAccordion';
import RuleEmptyState from './RuleEmptyState';
import SortableRuleList from './SortableRuleList';

type Props = {
  data: RuleAccordionProps[];
  isLoading: boolean;
  emptyStateTitle: string;
  emptyStateDescription: string;
  onReorder?: (orderedIds: string[]) => void;
  isReorderDisabled?: boolean;
};

const RuleList = ({
  data,
  isLoading,
  emptyStateTitle,
  emptyStateDescription,
  onReorder,
  isReorderDisabled,
}: Props) => {
  if (!isLoading && data.length === 0) {
    return (
      <RuleEmptyState
        title={emptyStateTitle}
        description={emptyStateDescription}
      />
    );
  }

  if (onReorder) {
    return (
      <SortableRuleList
        data={data}
        onReorder={onReorder}
        disabled={isReorderDisabled}
      />
    );
  }

  return (
    <FlexColumn sx={{ gap: 2 }}>
      {data.map((item) => (
        <RuleAccordion key={item.id} {...item} />
      ))}
    </FlexColumn>
  );
};

export default RuleList;
